export default {
  profile: "Profile",
  generalInformation: "General information",
  notificationSettings: "Notification settings",
};
